import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import useToken from "../../../helpers/useToken"
import TMHLoader from "../../TMHLoader/TMHLoader"
import Switch from "react-switch";

export default function RewardCodes({ notify, platforms, setPlatforms }) {
    const { token } = useToken()
    const [isLoading, setIsLoading] = useState(false)
    const [platformId, setPlatformId] = useState()
    const [codeData, setCodeData] = useState("")
    const [isOpenAddCodeModal, setIsOpenAddCodeModal] = useState(false)
    const [platformPartnerOverView, setPlatformPartnerOverView] = useState()

    useEffect(() => {
        const initData = async () => {
            console.log('Codes OverView: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            fetch(process.env.REACT_APP_BASE_URL + "rewards/reward_code_overview", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        if (result.ok) {
                            setPlatformPartnerOverView(json.data)
                            setIsLoading(false)
                        }
                        else {
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token, platforms])

    const addCode = () => {
        if (codeData === '') return

        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'codes': codeData.split("\n"),
                'partner_id': platformId
            })
        }

        fetch(process.env.REACT_APP_BASE_URL + "rewards/add_codes", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    if (result.ok) {
                        notify('tl', 'Add Code Successful!', 'success')
                        setIsOpenAddCodeModal(false)
                        setIsLoading(false)

                        setPlatforms([...platforms])
                    }
                    else {
                        console.log(result.json)
                        notify('tl', 'Add Code failed: ' + json.message, 'danger')
                        setIsOpenAddCodeModal(false)
                        setIsLoading(false)
                    }
                }
            )
    }

    const updatePlatform = (item_index) => {
        var platformsTemp = [...platformPartnerOverView]

        var partner_id = platformsTemp[item_index].partner_id
        var platform_status = !platformsTemp[item_index].status
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({
                'status': platform_status,
                'platform_id': partner_id
            })
        }

        fetch(process.env.REACT_APP_BASE_URL + "rewards/update_platform", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    if (result.ok && Boolean(json.data)) {
                        notify('tl', 'Edit Status Successful!', 'success')

                        platformsTemp[item_index].status = !platformPartnerOverView[item_index].status
                        setIsLoading(false)

                    }
                    else {
                        notify('tl', 'Edit Status failed: ' + json.message, 'danger')
                        setIsLoading(false)
                    }
                }
            )
    }

    const processAMZCodeFromMails = () => {
        var number_emails = 200
        if (!window.confirm("It can take about 2-3 minutes to check the latest "+ String(number_emails) + " emails, do you agree?")) { return; }

        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders
        }

        const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')

        var params = new URLSearchParams({
            'number_emails': number_emails,
            'from_email': 'codes@themoviehouse.tv',
            'report_email': isDev ? "tmhtest8@gmail.com": "info@themoviehouse.tv"
        })

        fetch(process.env.REACT_APP_BASE_URL + "rewards/add_amazon_codes_from_mail?" + params, requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    var data = json.data
                    if (result.ok && data) {
                        var msg = 'Successful!'
                        msg += "\nTotal Email Checks: " + String(data.number_emails ?? 0)
                        msg += "\nTotal Codes Received: " + String(data.number_codes ?? 0)
                        msg += "\nNew Codes: " + String(data.number_new_codes ?? 0)
                        msg += "\nExisting Codes: " + String(data.number_existing_codes ?? 0)
                        notify('tl', msg, 'success', 20)

                    }
                    else {
                        notify('tl', 'Failed: ' + json.message, 'danger')
                    }
                }
            ).finally(() =>  setIsLoading(false))
    }

    return (
        <TMHLoader active={isLoading}>
            <Modal className=".bg-dark" isOpen={isOpenAddCodeModal}>
                <ModalHeader tag="h2">Add Reward Codes</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="4">
                            Platform Partner:
                        </Col>
                        <Col>
                            <Input value={platformId} onChange={(e) => setPlatformId(e.target.value)} className="text-dark" type="select">
                                {
                                    platforms?.map((data) => {
                                        return (<option value={data.id} key={data.id}>{data.name}</option>)
                                    })
                                }
                            </Input>
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md="12">
                            Codes (one code per line):
                        </Col>
                        <Col>
                            <Input value={codeData} onChange={(e) => setCodeData(e.target.value)} className="p-2 text-dark" bsSize="lg" rows="5" cols="50" type="textarea" />
                        </Col>

                    </Row>
                    <Row className="text-center">
                        <Col md="6">
                            <Button onClick={() => addCode()} color="success">Add</Button>
                        </Col>
                        <Col md="6">
                            <Button onClick={() => setIsOpenAddCodeModal(false)} color="danger">Cancel</Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>

            <Row>
                <Col sm="12" md="6">
                    <Card className="card-chart">
                        <CardHeader>
                            <CardTitle tag="h2">Reward Codes Overview</CardTitle>
                        </CardHeader>
                        <CardBody>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Partner Name </th>
                                        <th>Available</th>
                                        <th>Claimed</th>
                                        <th>Total</th>
                                        <th>Enabled</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {platformPartnerOverView?.map((data, index) => {
                                        return (<tr key={data.partner_id}>
                                            <td>{data.name}</td>
                                            <td>{data.available}</td>
                                            <td>{data.claimed}</td>
                                            <td>{data.available + data.claimed} </td>
                                            <td>
                                                <Switch onChange={() => updatePlatform(index)} checked={data.status} />
                                            </td>
                                        </tr>)
                                    })}
                                </tbody>
                            </Table>
                            <Button onClick={() => {
                                setCodeData("")
                                if (platforms) setPlatformId(platforms[0].id)
                                setIsOpenAddCodeModal(true)
                            }} className="mt-3">
                                Add Codes
                            </Button>

                            <Button onClick={() => processAMZCodeFromMails()} className="mt-3">
                                Get Amazon Codes From Mail
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}